// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"1bfa4370","977":"52e9538e"}[chunkId] + ".chunk.js";
};